import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '@core/services';
import { User } from '@shared/models';

import { AuthService } from './auth.service';

export const guestGuard: CanActivateFn = async () => {
  const storage = inject(StorageService);
  const router = inject(Router);
  const auth = inject(AuthService);

  const user = await storage.get<User>('me');

  if (!user) {
    return true;
  }

  return router.createUrlTree([auth.getRedirectPath(user)]);
};
